var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHowItWorksInbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6655 30H40.6655L35.6655 37.5H25.6655L20.6655 30H5.66553",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2905 12.775L5.66553 30V45C5.66553 46.3261 6.19231 47.5979 7.12999 48.5355C8.06768 49.4732 9.33944 50 10.6655 50H50.6655C51.9916 50 53.2634 49.4732 54.2011 48.5355C55.1387 47.5979 55.6655 46.3261 55.6655 45V30L47.0405 12.775C46.6266 11.942 45.9885 11.2409 45.1979 10.7507C44.4074 10.2605 43.4957 10.0005 42.5655 10H18.7655C17.8353 10.0005 16.9237 10.2605 16.1331 10.7507C15.3426 11.2409 14.7045 11.942 14.2905 12.775V12.775Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksInbox);
export default __webpack_public_path__ + "static/media/how-it-works-inbox.0a8d9b24678854bb7442c25b4aec3f42.svg";
export { ForwardRef as ReactComponent };